/* eslint-disable react/prop-types */
/* eslint-disable import/no-absolute-path */
import React from 'react';

const Icon = ({ name, ...rest }) => {
  const [path, setPath] = React.useState(false);

  React.useEffect(() => {
    if (!name) return;
    const importIcon = async () => {
      try {
        const { default: _path } = await import(`../../../svgs/${name}.svg`);
        setPath(_path);
      } catch (err) {
        console.error(err);
      }
    };
    importIcon();
  }, [name]);

  return <>{path && <img src={path} alt=" " />}</>;
};

export default Icon;
